import banner from '../../../assets/industries/ondemand.svg'

import tick from '../../../assets/industries/tick.webp'


export const bannerData = {
    title1: 'On Demand Services',
    title2: 'App Development',
    desc: 'Providing dedicated app developers for on demand app development.',
    img: banner,
    btnTitle: 'Hire App Developers'
}

export const hireData = {
    img: tick,
    title: 'Entrust On Demand Services',
    points: [
      'Competence in custom on demand app development services',
      'Flexible engagement models',
      'UI/UX optimized development',
      'Instant chat support',
      'Diverse technology stack',
      'Data privacy protection'

    ]
}

export const webDesignData = {
    title1: 'Full Spectrum of',
    title1Span: 'eCommerce Website Design',
    title2: 'and Development Services',
    cards: [
        {
            title: 'Custom On Demand App Development Solutions',
            desc: 'Launch your fully customized on demand app to disrupt the multi million mobile app industry. Boost your business by outsourcing on demand services application development to Codezone.',
        },
        {
            title: 'On Demand Payment Solutions',
            desc: 'Stay competitive in today’s gig economy by integrating on demand payment solutions. Hire experienced on demand app developers to create UI/UX optimized on demand apps and captivate a large customer base.',
        },
        {
            title: 'On Demand Delivery App Development',
            desc: 'Get your own Uber Eats like delivery app packed with all on demand services features. Enable seamless access to your customers by hiring dedicated development teams from a trusted on demand app development company.',
        },
        {
            title: 'On demand Services Web App Development',
            desc: 'Get ahead of the competition by launching an on demand services web application along with the mobile version. Codezone offers experienced on demand web application development services to innovative businesses.',
        },
        {
            title: 'On Demand Appointment App',
            desc: 'Provide frictionless services to your patients by allowing appointment scheduling through on demand appointment apps. Hire remote developers to build on demand services app for your clinics and hospitals in reasonable time and price.',
        },
        {
            title: 'On Demand Services Solutions',
            desc: 'Enter the on demand services market to build a successful business. We offer all types of custom on demand app development services including B2C, B2B, and C2C. Get your on demand services app idea into reality today.',
        },
    ]
}